<template>
    <div v-if="lineData">
        <div class="tab-panel padded relative">
            <sales-overview :height="200" :width="500" :chartData="lineData"></sales-overview>

            <div class="options">
                <v-select 
                    label="description" 
                    placeholder="Results by ..." 
                    v-model="selectedRange" 
                    :options="ranges">
                </v-select>
            </div>
        </div>

        <div v-if="includeTotals && totals" class="border-top-light bg-lighter p-3 mt-3">
            <div class="panel stats narrow flex-all d-flex">
                <div v-for="total in totals" class="separator mr-3 pr-5">
                    <h6>{{ total.label }}</h6>
                    <h1>{{ total.value }} &euro;</h1>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SalesOverview from '@/tools/charts/SalesOverview.js'
    import extendedVSelect from '@/extends/vue-select'

    export default {
        props: {
            path: String,
            includeTotals: {
                type: Boolean,
                default: true,
            }
        },
        data: function() {
            return {
                selectedRange: '',
                params: null,
            }
        },
        asyncComputed: {
            async lineData() {
                if (this.ranges) {                    
                    // Set dynamic parameters (we need them to fetch the chart JSON)

                    this.params = {
                        accountType: 1,
                        entityId: 1,
                        chartView: this.selectedRange.id,
                    }

                    try {
                        let id = this.selectedRange.id || null;
                        let response = await axios.get(this.path, { params: this.params ? this.params : null });

                        if (response && response.status === 200) {
                            return response.data;
                        }
                    }
                    catch(error) {
                        this.$toasted.error(error.response.data.message);
                    }
                }
            },
            async ranges() {
                try {
                    let response = await axios.get('api/settings/GetChartViewList');

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        // Set the default selected range

                        this.selectedRange = response.data[0];

                        return response.data;
                    }
                }
                catch(error) {
                    this.$toasted.error(error.response.data.message);
                }
            },
        },
        computed: {
            totals: function() {
                let vm = this;
                let totals = [];

                if (this.lineData && this.lineData.datasets) {
                    let datasets = this.lineData.datasets;

                    for (let key in datasets) {
                        if (datasets[key].fields !== undefined) {
                            for (let label in datasets[key].fields) {
                                totals.push({ label: label, value: datasets[key].fields[label] });
                            }
                        }
                    }
                }

                return totals;
            }
        },
        components: {
            vSelect: extendedVSelect,
            SalesOverview
        }
    }
</script>

<style lang="scss" scoped>
    .options {
        position: absolute;
        top: 1.25rem;
        right: 1.5rem;
        max-width: 10rem;
    }
</style>


// WEBPACK FOOTER //
// Chart.vue?434746c5